import React from 'react';

import { Link } from 'react-router-dom';

import classes from 'components/common/ErrorPages/ErrorPages.module.scss';

const PageNotFoundMobile = () => {
    return (
        <div className={classes.message}>
            <div className={classes.description}>
                <h1>Sorry, Page/Item Not Found</h1>
            </div>
            <div>
                <Link to={'/'}>Go to homepage</Link>
            </div>
        </div>
    );
};
export default PageNotFoundMobile;
